import * as React from 'react'
import {useTranslation} from 'react-i18next'

const CustomShowMore = ({showMore, isShowingMore, toggleShowMore, popup}) => {
  const {t} = useTranslation()
  return (<>

    {showMore && <a className={"show-more-elements"} data-once="show-more-elements">
      {!isShowingMore && <span
        className="seemore icon bbicon-plus-square"
        onClick={() => {toggleShowMore()}} >
        {t('Show more')}
      </span>}
      {isShowingMore && <span
        className="seeless icon bbicon-minus-square"
        onClick={() => {toggleShowMore()}}>
        {t('Hide')}
      </span>}
    </a>}
  </>)
}

export default CustomShowMore
